import script from "./AuditLogComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuditLogComponent.vue?vue&type=script&lang=ts&setup=true"

import "./AuditLogComponent.vue?vue&type=style&index=0&id=3216ad18&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3216ad18"]])

export default __exports__